import React from 'react';
import { OrderDirection } from '../../../../../../gen-src/queries';
import { OrderBy } from './OrderBy';
import { DefaultDirections, SortProviderProps } from './SortProviderProps';

type SortProviderNoUrlState<OrderFields extends string> = OrderBy<OrderFields>;

export class SortProviderNoUrl<OrderFields extends string>
  extends React.Component<SortProviderProps<OrderFields>, SortProviderNoUrlState<OrderFields>> {

  public constructor(props: SortProviderProps<OrderFields>) {
    super(props);
    this.state = {
      direction: this.props.validOrderFieldsWithDefaultDirections[this.props.defaultField],
      field: this.props.defaultField,
    };
  }

  public override render() {
    return this.props.children({
      orderBy: this.state,
      updateSortOrder: this.updateOrder,
    });
  }

  private updateOrder = (sortField: string) => {
    const validatedSortField = validateValue(sortField, this.props.validOrderFieldsWithDefaultDirections);
    if (validatedSortField === null) {
      return;
    }

    const newDirection: OrderDirection = this.state.field === sortField
      ? this.state.direction === OrderDirection.ASC ? OrderDirection.DESC : OrderDirection.ASC
      : this.props.validOrderFieldsWithDefaultDirections[validatedSortField] || OrderDirection.ASC;

    this.setState({
      direction: newDirection,
      field: validatedSortField,
    });
  }
}

function validateValue<OrderFields extends string>(value: string, validTypes: DefaultDirections<OrderFields>): OrderFields | null {
  // Because webclient types are not all uppercase, we can't normalize as in GraphQL-only types
  if (value in validTypes) {
    return value as OrderFields;
  } else {
    return null;
  }
}
